// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var DEFAULT_LIST_SORT = { field: "", order: "ASC" };
export var resolveThreeStateSort = function (currentSort, requestedSort, defaultSort) {
    if (defaultSort === void 0) { defaultSort = DEFAULT_LIST_SORT; }
    if ((currentSort === null || currentSort === void 0 ? void 0 : currentSort.field) !== requestedSort.field) {
        return __assign(__assign({}, requestedSort), { order: "ASC" });
    }
    if (currentSort.order === "ASC") {
        return __assign(__assign({}, requestedSort), { order: "DESC" });
    }
    return defaultSort;
};
